import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BrowserReloadDialogComponent } from '../components/browser-reload-dialog/browser-reload-dialog.component';

import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class BuildInfoCheckService {
  private _onReloadPrompt: Subject<void> = new Subject<void>();
  public readonly onReloadPrompt: Observable<void> = this._onReloadPrompt.asObservable();

  private _subheader: string;
  private _currentDate = '';

  private _isDialogOpen = false;
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private dialog: MatDialog
  ) {}

  public initBuildFileCheck(subheader?: string) {
    this._subheader = subheader;

    if (this.appConfigService.config.name !== 'dev') {
      setInterval(() => {
        this.checkBuildDate('/build-info.json');
      }, 60000);
      this.checkBuildDate('/build-info.json');
    }
  }

  public openDialog(subheader: string) {
    if (this._isDialogOpen) return;
    this.dialog.open(BrowserReloadDialogComponent, {
      disableClose: true,
      data: subheader,
    });
    this._isDialogOpen = true;
    this._onReloadPrompt.next();
  }
  private checkBuildDate(url) {
    this.http
      .get<IBuildInfo>(url + '?t=' + new Date().getTime())
      .pipe(
        catchError((err) => {
          if (err.status === 404) {
            console.error(err, 'Could not get build info file');
          }
          return EMPTY;
        })
      )
      .subscribe((response) => {
        const date = response.date;
        const dateChanged = this.hasDateChanged(this._currentDate, date);

        if (dateChanged) {
          this.openDialog(this._subheader);
        }
        this._currentDate = date;
      });
  }
  private hasDateChanged(currentDate, newDate) {
    if (!currentDate) {
      return false;
    }
    return this._currentDate !== newDate;
  }
}

export interface IBuildInfo {
  date: string;
}
